import React from 'react';
import LoginSideImage from "../../images/IotLogin.png"
import Logo from "../../images/closecarbon_logo_1-removebg-preview 1.png"
import { useState } from 'react';
import { useDispatch } from "react-redux";
import jwt_decode from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { login } from '../../apis/UserDashboard/authentication';
const IotDeviceLogin = () => {

      const [showPassword, setShowPassword] = useState(false);
      const [email, setEmail] = useState("");
        const [password, setPassword] = useState("");
          const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
const navigate = useNavigate()
  const dispatch = useDispatch();

  const handleLogin = async (e) => {
    setLoading(true);
    e.preventDefault();

    const response = await login(email, password);
    console.log('login', response);
    if (response?.data?.statusCode === 200) {
      const tokenDecoded = jwt_decode(response.data.message);
console.log('tokenDecoded', tokenDecoded);

// if(!!tokenDecoded?.twoFaEnabled) {
//   setStage(5);
//   setToken(response.data.message);
// }else {
  if (
    tokenDecoded?.role === "thirdParty" ||
    tokenDecoded?.role === "admin"
  ) {
    toast.error("Please log in with a user account");
  } else {
    localStorage.setItem("token", response.data.message);
    dispatch({
      type: "USER_LOGIN_SUCCESS",
      payload: {
        token: response.data.message,
      },
    });
    navigate("/device/dashboard");
    window.scrollTo(0, 0);
  }
// }

      
    } else {
      setError(true);
    }
    setLoading(false);
  };
      
  return (
<div className='flex max-auto justify-items-center h-screen'>
    <div>
        <img className='w-[656px] h-[897px] mt-[48px] ml-[250px] object-fill' src={LoginSideImage} alt='Login-side-Image'></img>
    </div>
    {/* login image */}

    {/* login */}
    <div>
        <div className='bg-[#FAFAFA] w-[592px] h-[800px] mt-[75px]  rounded-xl mr-[32px] ml-[32px] mb-[64px] '>
            <img src={Logo} className='w-[90px] pt-48 justify-self-center'></img>

{/* <form className='h-[439px] w-[528px]   justify-self-center'>
    <h1 className='justify-self-center mt-10 text-[32px] font-semibold'>Welcome back!</h1>
    <p className='justify-self-center'>Please enter your login credentials to continue</p>

<div className='mt-10'>
<h1>
        <label className='text-[16px]'>
        Email Address
    </label>

</h1>

    < input type="mail" className='w-[500px] h-16 rounded-xl border-black p-3 text-grey-500 onfocus:border-grey ring-slate-950 ' placeholder='Enter email address'/>
</div>

<div>
<h1>
    <label>
        Password
    </label>
</h1>

    <input type="password" />
</div>
    

</form> */}
 <form className="h-[439px] w-[528px] mx-auto p-6" onSubmit={handleLogin}>
      <h1 className="text-[32px] font-semibold text-center mt-10">Welcome back!</h1>
      <p className="text-center text-gray-600">
        Please enter your login credentials to continue
      </p>

      <div className="mt-10">
        <label className="block text-[16px] mb-2">Email Address</label>
        <input
          type="email"
          placeholder="Enter email address"
          value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setError(false)}}
          className="w-full h-16 rounded-xl border border-gray-300 px-4 text-gray-700 focus:outline-none focus:ring-2 focus:ring-slate-950"
        />
      </div>

      <div className="mt-6 relative">
        <label className="block text-[16px] mb-2">Password</label>
        <input
          type={showPassword ? 'text' : 'password'}
            placeholder="Enter password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setError(false)}}
          className="w-full h-16 rounded-xl border border-gray-300 px-4 pr-14 text-gray-700 focus:outline-none focus:ring-2 focus:ring-slate-950"
        />
        <span
          onClick={() => setShowPassword(!showPassword)}
          className="absolute right-4 mt-[20px] transform -translate-y-1/2 cursor-pointer"
        >
          {showPassword ? (
            // 👁️ Eye Open SVG
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              className="w-8 h-8 text-gray-500"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
              />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
              />
            </svg>
          ) : (
            // 🙈 Eye Closed SVG
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              className="w-8 h-8 text-gray-500"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M13.875 18.825A10.05 10.05 0 0112 19c-4.477 0-8.268-2.943-9.542-7a9.974 9.974 0 012.625-4.033M15 12a3 3 0 01-3 3m0-6a3 3 0 013 3m6 0c-.312.984-.822 1.887-1.5 2.659M6.455 6.455A9.978 9.978 0 0112 5c4.477 0 8.268 2.943 9.542 7a9.978 9.978 0 01-4.507 5.292M3 3l18 18"
              />
            </svg>
          )}
        </span>
      </div>

      <div className="mt-20">
        <button
          type="submit"
          className="w-full text-2xl py-10 gap-5  text-white font-semibold rounded bg-gradient-to-r from-[#038B47] to-[#00AED9] hover:from-green-700  hover:to-green-600 transition-all shadow flex "
        >
            <h1 className='justify-self-center ml-80'>
                
          Login
          
            </h1>
            
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.0459 10.7959L9.29594 14.5459C9.08459 14.7573 8.79795 14.876 8.49906 14.876C8.20018 14.876 7.91353 14.7573 7.70219 14.5459C7.49084 14.3346 7.37211 14.0479 7.37211 13.7491C7.37211 13.4502 7.49084 13.1635 7.70219 12.9522L9.53125 11.125H1.75C1.45163 11.125 1.16548 11.0065 0.954505 10.7955C0.743526 10.5845 0.625 10.2984 0.625 10C0.625 9.70163 0.743526 9.41548 0.954505 9.2045C1.16548 8.99353 1.45163 8.875 1.75 8.875H9.53125L7.70406 7.04594C7.59942 6.94129 7.5164 6.81706 7.45977 6.68033C7.40314 6.5436 7.37399 6.39706 7.37399 6.24906C7.37399 5.95018 7.49272 5.66353 7.70406 5.45219C7.91541 5.24084 8.20205 5.12211 8.50094 5.12211C8.79982 5.12211 9.08647 5.24084 9.29781 5.45219L13.0478 9.20219C13.1526 9.30683 13.2356 9.43112 13.2923 9.56793C13.3489 9.70474 13.3779 9.85139 13.3778 9.99945C13.3776 10.1475 13.3482 10.2941 13.2912 10.4308C13.2343 10.5675 13.1509 10.6915 13.0459 10.7959ZM17.5 0.625H12.25C11.9516 0.625 11.6655 0.743526 11.4545 0.954505C11.2435 1.16548 11.125 1.45163 11.125 1.75C11.125 2.04837 11.2435 2.33452 11.4545 2.5455C11.6655 2.75647 11.9516 2.875 12.25 2.875H17.125V17.125H12.25C11.9516 17.125 11.6655 17.2435 11.4545 17.4545C11.2435 17.6655 11.125 17.9516 11.125 18.25C11.125 18.5484 11.2435 18.8345 11.4545 19.0455C11.6655 19.2565 11.9516 19.375 12.25 19.375H17.5C17.9973 19.375 18.4742 19.1775 18.8258 18.8258C19.1775 18.4742 19.375 17.9973 19.375 17.5V2.5C19.375 2.00272 19.1775 1.52581 18.8258 1.17417C18.4742 0.822544 17.9973 0.625 17.5 0.625Z" fill="white"/>
</svg>

          
        </button>
      </div>
    </form>

        </div>
    </div>

</div>
  );
};

export default IotDeviceLogin;